// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.icon-wrapper {
	position: absolute;
	display: flex;
	flex-direction: column-reverse;
	bottom: 0;
	z-index: 501;
	-webkit-user-select: none;
	        user-select: none;
}
.icon-column {
	position: absolute;
	bottom: 0;
	left: 0;
	display: flex;
	flex-direction: row;
	flex-shrink: 1;
	background-color: var(--primary-color1);
	cursor: pointer;
	top: unset;
	z-index: 5001;
	animation: scroll-from-left 0.3s ease-in-out;
	transition: all 0.3s ease-in-out;
	-webkit-user-select: none;
	        user-select: none;
}
.panel-restrictive-wrapper {
	position: absolute;
	display: inline;
	bottom: 2.5rem;
	left: 0rem;
	z-index: 5000;
}
.vertical-menu {
	display: flex;
	flex-direction: row;
	animation: scroll-from-left 0.3s ease-in-out;
	justify-items: space-evenly;
}

.icon {
	display: flex;
	width: 3.2rem;
	height: 3.2rem;
	align-items: center;
	align-content: center;
	justify-items: center;
	justify-content: center;
}
.icon.shimmer-on {
	width: 3.2rem;
	height: 3.2rem;
	position: relative;
	overflow: hidden;
}
.icon.shimmer-on::after {
	content: "";
	position: absolute;
	top: 0%;
	left: 200%;
	width: 200%; /* Increase width for a more gradual gradient */
	height: 100%; /* Increase height to match */
	background-size: 100% 100%;
	background-repeat: no-repeat;
	background: linear-gradient(
		120deg,
		transparent 0%,
		transparent 20%,
		rgba(219, 230, 250, 0.527) 50%,
		/* transparent 70%, */ transparent 100%
	);
	/* transition: left 600ms; */
	animation-name: shimmer;
	animation-duration: 2s;
	animation-iteration-count: infinite;
	opacity: 1;
}
@keyframes shine {
	0% {
		left: -200%;
	}
	7% {
		left: 100%;
	}
	100% {
		left: 150%;
	}
}

.icon.active {
	display: flex;
	width: 3.2rem;
	height: 3.2rem;
	align-items: center;
	align-content: center;
	justify-items: center;
	justify-content: center;
	background-color: var(--primary-color2);
}

.icon:hover {
	background-color: var(--primary-color2);
}
.icon img {
	width: 2rem;
	height: 2rem;
	object-fit: cover;
}
.super-user-button {
	display: flex;
	text-justify: center;
	text-align: center;
	align-content: center;
	justify-content: center;
	align-items: center;
	width: 3.2rem;
	height: 3.2rem;
}
.super-user-button img {
	color: white;
	width: 2rem;
	height: 2rem;
	text-align: center;
}
@media (max-width: 300px) {
	.icon-wrapper {
		position: absolute;
		display: flex;
		flex-direction: column-reverse;
		bottom: 0;
		z-index: 3001;
		flex-wrap: wrap;
	}
	.panel-content {
		margin-top: 0px;
	}
}
@media (min-width: 500px) {
	.icon-wrapper {
		position: absolute;
		top: 0rem;
		left: 0rem;
		/* flex-direction: row; */
		justify-content: space-between;
		/* flex-basis: 200px; */
		/* flex-wrap: wrap; */
		z-index: 401;
		bottom: unset;
		/* width: 45rem; */
	}
	.panel-restrictive-wrapper {
		position: absolute;
		display: inline;
		top: 0;
		left: 5rem;
		z-index: 5000;
		height: fit-content;
	}
	.panel-area-wrapper {
		position: absolute;
		top: 0;
		left: 0;
	}

	.vertical-menu {
		display: flex;
		flex-direction: column;
		height: 100%;
		animation: scroll-from-top 0.2s ease-in;
	}

	.icon-column {
		position: absolute;
		left: 0;
		top: 0;
		display: flex;
		flex-direction: column;
		background-color: var(--primary-color1);
		height: fit-content;
		width: fit-content;
		z-index: 5001;
	}

	.icon {
		width: 5rem;
		height: 5rem;
	}
	.icon.shimmer-on {
		display: flex;
		width: 5rem;
		height: 5rem;
		align-items: center;
		align-content: center;
		justify-items: center;
		justify-content: center;
	}
	.icon.active {
		display: flex;
		width: 5rem;
		height: 5rem;
		align-items: center;
		align-content: center;
		justify-items: center;
		justify-content: center;
		background-color: var(--primary-color2);
	}
	.icon:hover {
		background-color: var(--primary-color2);
	}
	.icon img {
		width: 3rem;
		height: 3rem;
		object-fit: cover;
	}
	.super-user-button {
		display: flex;
		text-justify: center;
		text-align: center;
		align-content: center;
		justify-content: center;
		align-items: center;
		width: 5rem;
		height: 5rem;
		margin: unset;
		text-justify: center;
		text-align: center;
	}
	.super-user-button img {
		color: white;
		width: 2.7rem;
		height: 2.7rem;
	}
}
@keyframes scroll-from-left {
	0% {
		opacity: 1;
		transform: translateX(-100%);
	}

	100% {
		opacity: 1;
		transform: translateX(0%);
	}
}
`, "",{"version":3,"sources":["webpack://./src/components/MapLeftMenu/MapLeftMenu.css"],"names":[],"mappings":"AAAA;CACC,kBAAkB;CAClB,aAAa;CACb,8BAA8B;CAC9B,SAAS;CACT,YAAY;CACZ,yBAAiB;SAAjB,iBAAiB;AAClB;AACA;CACC,kBAAkB;CAClB,SAAS;CACT,OAAO;CACP,aAAa;CACb,mBAAmB;CACnB,cAAc;CACd,uCAAuC;CACvC,eAAe;CACf,UAAU;CACV,aAAa;CACb,4CAA4C;CAC5C,gCAAgC;CAChC,yBAAiB;SAAjB,iBAAiB;AAClB;AACA;CACC,kBAAkB;CAClB,eAAe;CACf,cAAc;CACd,UAAU;CACV,aAAa;AACd;AACA;CACC,aAAa;CACb,mBAAmB;CACnB,4CAA4C;CAC5C,2BAA2B;AAC5B;;AAEA;CACC,aAAa;CACb,aAAa;CACb,cAAc;CACd,mBAAmB;CACnB,qBAAqB;CACrB,qBAAqB;CACrB,uBAAuB;AACxB;AACA;CACC,aAAa;CACb,cAAc;CACd,kBAAkB;CAClB,gBAAgB;AACjB;AACA;CACC,WAAW;CACX,kBAAkB;CAClB,OAAO;CACP,UAAU;CACV,WAAW,EAAE,+CAA+C;CAC5D,YAAY,EAAE,6BAA6B;CAC3C,0BAA0B;CAC1B,4BAA4B;CAC5B;;;;;;EAMC;CACD,4BAA4B;CAC5B,uBAAuB;CACvB,sBAAsB;CACtB,mCAAmC;CACnC,UAAU;AACX;AACA;CACC;EACC,WAAW;CACZ;CACA;EACC,UAAU;CACX;CACA;EACC,UAAU;CACX;AACD;;AAEA;CACC,aAAa;CACb,aAAa;CACb,cAAc;CACd,mBAAmB;CACnB,qBAAqB;CACrB,qBAAqB;CACrB,uBAAuB;CACvB,uCAAuC;AACxC;;AAEA;CACC,uCAAuC;AACxC;AACA;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;AAClB;AACA;CACC,aAAa;CACb,oBAAoB;CACpB,kBAAkB;CAClB,qBAAqB;CACrB,uBAAuB;CACvB,mBAAmB;CACnB,aAAa;CACb,cAAc;AACf;AACA;CACC,YAAY;CACZ,WAAW;CACX,YAAY;CACZ,kBAAkB;AACnB;AACA;CACC;EACC,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,aAAa;EACb,eAAe;CAChB;CACA;EACC,eAAe;CAChB;AACD;AACA;CACC;EACC,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,yBAAyB;EACzB,8BAA8B;EAC9B,uBAAuB;EACvB,qBAAqB;EACrB,YAAY;EACZ,aAAa;EACb,kBAAkB;CACnB;CACA;EACC,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,UAAU;EACV,aAAa;EACb,mBAAmB;CACpB;CACA;EACC,kBAAkB;EAClB,MAAM;EACN,OAAO;CACR;;CAEA;EACC,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,uCAAuC;CACxC;;CAEA;EACC,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,aAAa;EACb,sBAAsB;EACtB,uCAAuC;EACvC,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;CACd;;CAEA;EACC,WAAW;EACX,YAAY;CACb;CACA;EACC,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;EACrB,qBAAqB;EACrB,uBAAuB;CACxB;CACA;EACC,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;EACrB,qBAAqB;EACrB,uBAAuB;EACvB,uCAAuC;CACxC;CACA;EACC,uCAAuC;CACxC;CACA;EACC,WAAW;EACX,YAAY;EACZ,iBAAiB;CAClB;CACA;EACC,aAAa;EACb,oBAAoB;EACpB,kBAAkB;EAClB,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,kBAAkB;CACnB;CACA;EACC,YAAY;EACZ,aAAa;EACb,cAAc;CACf;AACD;AACA;CACC;EACC,UAAU;EACV,4BAA4B;CAC7B;;CAEA;EACC,UAAU;EACV,yBAAyB;CAC1B;AACD","sourcesContent":[".icon-wrapper {\n\tposition: absolute;\n\tdisplay: flex;\n\tflex-direction: column-reverse;\n\tbottom: 0;\n\tz-index: 501;\n\tuser-select: none;\n}\n.icon-column {\n\tposition: absolute;\n\tbottom: 0;\n\tleft: 0;\n\tdisplay: flex;\n\tflex-direction: row;\n\tflex-shrink: 1;\n\tbackground-color: var(--primary-color1);\n\tcursor: pointer;\n\ttop: unset;\n\tz-index: 5001;\n\tanimation: scroll-from-left 0.3s ease-in-out;\n\ttransition: all 0.3s ease-in-out;\n\tuser-select: none;\n}\n.panel-restrictive-wrapper {\n\tposition: absolute;\n\tdisplay: inline;\n\tbottom: 2.5rem;\n\tleft: 0rem;\n\tz-index: 5000;\n}\n.vertical-menu {\n\tdisplay: flex;\n\tflex-direction: row;\n\tanimation: scroll-from-left 0.3s ease-in-out;\n\tjustify-items: space-evenly;\n}\n\n.icon {\n\tdisplay: flex;\n\twidth: 3.2rem;\n\theight: 3.2rem;\n\talign-items: center;\n\talign-content: center;\n\tjustify-items: center;\n\tjustify-content: center;\n}\n.icon.shimmer-on {\n\twidth: 3.2rem;\n\theight: 3.2rem;\n\tposition: relative;\n\toverflow: hidden;\n}\n.icon.shimmer-on::after {\n\tcontent: \"\";\n\tposition: absolute;\n\ttop: 0%;\n\tleft: 200%;\n\twidth: 200%; /* Increase width for a more gradual gradient */\n\theight: 100%; /* Increase height to match */\n\tbackground-size: 100% 100%;\n\tbackground-repeat: no-repeat;\n\tbackground: linear-gradient(\n\t\t120deg,\n\t\ttransparent 0%,\n\t\ttransparent 20%,\n\t\trgba(219, 230, 250, 0.527) 50%,\n\t\t/* transparent 70%, */ transparent 100%\n\t);\n\t/* transition: left 600ms; */\n\tanimation-name: shimmer;\n\tanimation-duration: 2s;\n\tanimation-iteration-count: infinite;\n\topacity: 1;\n}\n@keyframes shine {\n\t0% {\n\t\tleft: -200%;\n\t}\n\t7% {\n\t\tleft: 100%;\n\t}\n\t100% {\n\t\tleft: 150%;\n\t}\n}\n\n.icon.active {\n\tdisplay: flex;\n\twidth: 3.2rem;\n\theight: 3.2rem;\n\talign-items: center;\n\talign-content: center;\n\tjustify-items: center;\n\tjustify-content: center;\n\tbackground-color: var(--primary-color2);\n}\n\n.icon:hover {\n\tbackground-color: var(--primary-color2);\n}\n.icon img {\n\twidth: 2rem;\n\theight: 2rem;\n\tobject-fit: cover;\n}\n.super-user-button {\n\tdisplay: flex;\n\ttext-justify: center;\n\ttext-align: center;\n\talign-content: center;\n\tjustify-content: center;\n\talign-items: center;\n\twidth: 3.2rem;\n\theight: 3.2rem;\n}\n.super-user-button img {\n\tcolor: white;\n\twidth: 2rem;\n\theight: 2rem;\n\ttext-align: center;\n}\n@media (max-width: 300px) {\n\t.icon-wrapper {\n\t\tposition: absolute;\n\t\tdisplay: flex;\n\t\tflex-direction: column-reverse;\n\t\tbottom: 0;\n\t\tz-index: 3001;\n\t\tflex-wrap: wrap;\n\t}\n\t.panel-content {\n\t\tmargin-top: 0px;\n\t}\n}\n@media (min-width: 500px) {\n\t.icon-wrapper {\n\t\tposition: absolute;\n\t\ttop: 0rem;\n\t\tleft: 0rem;\n\t\t/* flex-direction: row; */\n\t\tjustify-content: space-between;\n\t\t/* flex-basis: 200px; */\n\t\t/* flex-wrap: wrap; */\n\t\tz-index: 401;\n\t\tbottom: unset;\n\t\t/* width: 45rem; */\n\t}\n\t.panel-restrictive-wrapper {\n\t\tposition: absolute;\n\t\tdisplay: inline;\n\t\ttop: 0;\n\t\tleft: 5rem;\n\t\tz-index: 5000;\n\t\theight: fit-content;\n\t}\n\t.panel-area-wrapper {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tleft: 0;\n\t}\n\n\t.vertical-menu {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\theight: 100%;\n\t\tanimation: scroll-from-top 0.2s ease-in;\n\t}\n\n\t.icon-column {\n\t\tposition: absolute;\n\t\tleft: 0;\n\t\ttop: 0;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tbackground-color: var(--primary-color1);\n\t\theight: fit-content;\n\t\twidth: fit-content;\n\t\tz-index: 5001;\n\t}\n\n\t.icon {\n\t\twidth: 5rem;\n\t\theight: 5rem;\n\t}\n\t.icon.shimmer-on {\n\t\tdisplay: flex;\n\t\twidth: 5rem;\n\t\theight: 5rem;\n\t\talign-items: center;\n\t\talign-content: center;\n\t\tjustify-items: center;\n\t\tjustify-content: center;\n\t}\n\t.icon.active {\n\t\tdisplay: flex;\n\t\twidth: 5rem;\n\t\theight: 5rem;\n\t\talign-items: center;\n\t\talign-content: center;\n\t\tjustify-items: center;\n\t\tjustify-content: center;\n\t\tbackground-color: var(--primary-color2);\n\t}\n\t.icon:hover {\n\t\tbackground-color: var(--primary-color2);\n\t}\n\t.icon img {\n\t\twidth: 3rem;\n\t\theight: 3rem;\n\t\tobject-fit: cover;\n\t}\n\t.super-user-button {\n\t\tdisplay: flex;\n\t\ttext-justify: center;\n\t\ttext-align: center;\n\t\talign-content: center;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\twidth: 5rem;\n\t\theight: 5rem;\n\t\tmargin: unset;\n\t\ttext-justify: center;\n\t\ttext-align: center;\n\t}\n\t.super-user-button img {\n\t\tcolor: white;\n\t\twidth: 2.7rem;\n\t\theight: 2.7rem;\n\t}\n}\n@keyframes scroll-from-left {\n\t0% {\n\t\topacity: 1;\n\t\ttransform: translateX(-100%);\n\t}\n\n\t100% {\n\t\topacity: 1;\n\t\ttransform: translateX(0%);\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
